module.exports = __webpack_public_path__ + "static/img/risk_sp2.072047d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/risk_sp2.png
// module id = 930
// module chunks = 1